// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2uxtz","choiceBoxes":"toolbarselects_choiceBoxes__3P9Qa","simpleField":"toolbarselects_simpleField__1D1lh"};